export enum CameraLocation {
    OtherLocation,
    Forward,
    Rear,
    Internal,
    Cargo,
    Left,
    Right
}
